import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: localStorage.getItem('at_token') || '',
    userName: undefined,
    id: undefined,
    nickName: undefined,
    org: undefined,
    tags: [],
    quota: [],
    sidebarCollapsed: false,

    systemName: undefined, // 系统名称(湖北光谷集团时-AI助手)
  },
  mutations: {
    // 保存token
    SET_TOKEN: (state, payload) => {
      state.token = payload.token;
      localStorage.setItem('at_token', state.token);
    },

    // 退出登录
    logout: (state) => {
      Object.keys(state).forEach((k) => {
        Vue.delete(state, k);
      });
      localStorage.clear();
    },

    // 保存用户信息
    SET_UserDetails: (state, userDetails) => {
      state.userName = userDetails.userName;
      state.id = userDetails.id;
      state.nickName = userDetails.nickName;
      state.org = userDetails.org;

      localStorage.setItem('at_userName', userDetails.userName);
      localStorage.setItem('at_userId', userDetails.id);
      localStorage.setItem('at_nickName', userDetails.nickName);
      localStorage.setItem('at_org', userDetails.org);
    },

    SET_Tags: (state, tags) => {
      state.tags = tags;
      localStorage.setItem('at_tags', JSON.stringify(tags));
    },

    SET_Quota: (state, quota) => {
      state.quota = quota;
      localStorage.setItem('at_quota', JSON.stringify(quota));
    },

    // 保存侧边栏展开收起状态
    SET_sidebarCollapsed: (state, payload) => {
      // console.log(state);
      // console.log(payload);
      state.sidebarCollapsed = payload;
    },
  },
  getters: {
    getToken: (state) => state.token,
    getSidebarCollapsed: (state) => state.sidebarCollapsed,
    getSystemName: (state) => state.systemName,
    getUserName: (state) => state.userName,
    getId: (state) => state.id,
  },
  actions: {},
  // modules: {
  //   tab,
  // },
});

export default store;
